import { useCallback, useState } from "react";
import { useGetNewReportMutation } from "features/trading/accounts";
import { NewReportRequest, NewReportResponse } from "helpers/types";
import { extractReportErrorMessage } from "./extractReportErrorMessage";

type UseReportCalculationOptions = {
  fallbackErrorMessage: string;
};

type ReportData = NewReportResponse["data"];

export const useReportCalculation = ({
  fallbackErrorMessage,
}: UseReportCalculationOptions) => {
  const [getNewReport, { isLoading: isCalculating }] =
    useGetNewReportMutation();
  const [error, setError] = useState("");

  const calculate = useCallback(
    async (args: NewReportRequest): Promise<ReportData | null> => {
      try {
        const response = await getNewReport(args).unwrap();
        return response.data;
      } catch (e) {
        setError(extractReportErrorMessage(e, fallbackErrorMessage));
        return null;
      }
    },
    [getNewReport, fallbackErrorMessage],
  );

  return { calculate, error, setError, isCalculating };
};
